export default [
  {
    path: '/official-20250715-main',
    component: () => import('./Main.vue'),
    meta: { id: 142, title: '夏季盲盒' },
  },
]
